jQuery(document).ready(function($) {
	$('.hamburger').on('click', function() {
		$(this).toggleClass('is-active')
		$('#menu-primary').toggleClass('is-active')
		$('#members-menu').toggleClass('is-hidden')
	})

	$('#internal-nav-title').on('click', function(e) {
		if ($(window).width() < 1024) {
			e.preventDefault()
			$(this)
				.parent()
				.toggleClass('is-active')
		}
	})
})
